import axios from 'axios';

// api/v3/front/schools/{school_guid}/users?role_guid[]=<rol></rol>
const SCHOOLS = '/v3/front/schools';

export function getSchoolUsers(schoolGuid, roleGuid) {
  return axios.get(`${SCHOOLS}/${schoolGuid}/users?role_guid[]=${roleGuid}`);
}
